export default __webpack_public_path__ + "static/image-9-c010a43d8e466575d5dbe059119fc32a.jpg";